export const capitalizeText = (string) => {
  if (string !== undefined) {
    return string.toLowerCase()
      .split(' ')
      .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
      .join(' ');
  }
}

export const currencyFormatter = (num) => {
  if (num > 999999) {
    return '$' + (num/1000000).toFixed(0) + 'm'
  } else if (num > 999) {
    return '$' + (num/1000).toFixed(0) + 'k'
  } else {
    return num
  }
}

export const yearFormatter = (num) => {
  return `${ Number((num/12).toFixed(1)) } years`
}
